<footer class="app-footer">
  <div class="footer-content">
    <div class="footer-links">
      <button
        class="footer-link"
        mat-button
        routerLink="/about-website"
        routerLinkActive="active"
      >
        საიტის შესახებ
      </button>

      <button
        class="footer-link"
        mat-button
        routerLink="/about-us"
        routerLinkActive="active"
      >
        სააგენტოს შესახებ
      </button>
    </div>

    <div class="footer-info">
      <div class="footer-info-item">
        <span class="footer-info-label">ცხელი ხაზის ნომერი:</span>
        <span class="footer-info-value">0322 56 08 08</span>
      </div>

      <div class="footer-info-item">
        <span class="footer-info-label">სამუშაო საათები:</span>
        <span class="footer-info-value">
          ორშაბათი-პარასკევი 09:00-დან 18:00 საათამდე
        </span>
      </div>
    </div>
  </div>

  <div class="footer-bottom">
    © სსიპ კულტურული მემკვიდრეობის დაცვის ეროვნული სააგენტო
  </div>
</footer>
